var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',_vm._g(_vm._b({attrs:{"no-body":"","img-src":_vm.imgSrc,"img-alt":_vm.imgAlt,"img-top":"","tag":"article"}},'b-card',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }